import * as React from "react";
import { Button, message } from "antd";

import "styles/customOrder.scss";
import CustomOrderInputForm from './CustomOrderInputForm';
import CustomOrderInputTable from './CustomOrderInputTable';
import CustomOrderFileUpload from './CustomOrderFileUpload';

import { CQ } from "utils/commonQuest";
import {
  saveCustomOrder,
  submitCustomOrder
} from "utils/interface";
import _ from 'lodash'
import moment from 'moment'

// 获取地址栏参数
import { getSearchVal } from "utils/tool";


class CustomOrder extends React.Component<any,any> {
  
  componentWillMount(){
    let search = this.props.location.search;
    let group_number = getSearchVal(search, "number");
    this.props.toSaveMode({group_number:group_number});
    this.props.getSkuList(); //初始化搜索表单sku下拉项
  }

  componentWillUnmount(){
    this.props.resetCustomOrder();
  }

  form;

  cancelEveryThing = () => {
    this.props.history.goBack();
  }

  _getGroupNumber = () => {
    let number = this.form.props.form.getFieldValue('group_number');
    if(!number){
      if(this.props.customData){
        if(this.props.customData.number){
          number = this.props.customData.number ;
        }
      }
    }
    return number;
  }

  _getFileUrl = () => {
    return this.props.customerFile ? this.props.customerFile.url : this.props.customData ? this.props.customData.file : ''
  }

  submitCustomOrder = () => {
    let group_number = this._getGroupNumber();
    if(!group_number){
      message.error('定制团号不能为空。');
      return;
    }
    if(this.props.editOrderId){
      message.error('请先保存修改。');
      return;
    }
    if(this.props.orderList && this.props.orderList.length){
      CQ(submitCustomOrder({
        group_number: group_number,
        file: this._getFileUrl(), //传递空字符串用于覆盖上次传递的连接
        post: this.props.orderList
      })).then((result)=>{
        if(result.error){
          this.props.toSaveMode({group_number: result.res.data}).then(()=>{
            this.props.history.replace('/app/customOrder?number=' + result.res.data);
          });
        }else{          //团号id
          message.success('提交成功！');
          this.props.history.goBack();
        }
      }).catch((err)=>{
        message.error(err);
      })
    }else{
      message.error('行程不能为空。');
    }
  }

  saveCustomOrder = () => {
    let group_number = this._getGroupNumber();
    if(!group_number){
      message.error('定制团号不能为空。');
      return;
    }
    if(this.props.editOrderId){
      message.error('请先保存修改。');
      return;
    }
    if(this.props.orderList && this.props.orderList.length){
      CQ(saveCustomOrder({
        group_number: group_number,
        file: this._getFileUrl(), //传递空字符串用于覆盖上次传递的连接
        post: this.props.orderList
      })).then((result)=>{
        if(result.error){
          message.error(result.res.msg);
        }else{          //团号id
          message.success('保存定制单成功！');
          this.props.toSaveMode({group_number: result}).then(()=>{
            this.props.history.replace('/app/customOrder?number=' + result);
          });
        }
      }).catch((err)=>{
        message.error(err);
      })
    }else{
      message.error('行程不能为空。');
    }
  }

  getActionButton = () => {
    let { customData } = this.props;
    // if(customData && customData.status == 1){
    return (
      <React.Fragment>
          <Button onClick={this.cancelEveryThing}>
            取消
          </Button>
          <Button type="primary" onClick={this.saveCustomOrder}>
            保存
          </Button>
          <Button type="primary" onClick={this.submitCustomOrder}>
            { customData && customData.status == 1 ? '追加行程' : '提交定制单'}
          </Button>
      </React.Fragment>
    )
  }

  _exchangeRate = (changeCost) => {
    if(changeCost){
      if(this.props.money && this.props.money.rate){
        return _.floor(_.divide(changeCost, this.props.money.rate), 2);
      }
    }
    return changeCost;
  }

  _resetForm = (order) => {
    let { form } = this.form.props;
    form.setFieldsValue({
      contact_name: order.contact_name,
      group_number: order.group_number,
      contact_pinyinSurname: order.contact_pinyinSurname,
      contact_pinyinName: order.contact_pinyinName,
      phone: order.phone,
      email: order.email,
      sku_id: order.sku_id,
      go_time: moment(order.go_time, 'YYYY-MM-DD'),
      tao_account: order.tao_account,
      payment: order.payment,
      id:order.id,
    }, async () => {
      if(order.sku_id){
        await this.props.getMoney({sku_id: order.sku_id})
      }
      
      form.setFieldsValue({
        num:order.num,
        price:order.price,
        adult_num:order.adult_num,
        adult_price:order.adult_price,
        children_num: order.children_num,
        children_price: order.children_price,
        baby_num: order.baby_num,
        baby_price: order.baby_price,
        change_cost: this._exchangeRate(order.change_cost),
      })
    })
  }

  _setFormByEdit = (record) => {
    let orderData = _.find(this.props.orderList, function(o) { return o.id == record.id; });
    this._resetForm(orderData);
  }

  render(){
    let { customData } = this.props;
    return (
      <div className={'customOrderContianer'}>
        <div className={'customOrderStateTitle'}>
          {
            customData && customData.number ? 
            `创建时间：${customData.create_time} 更新时间：${customData.update_time} 定制师：${customData.fullname}` : "新增定制单"
          }
        </div>
        {/* 新增定制Form表单 */}
        <CustomOrderInputForm
          wrappedComponentRef={(form) => this.form = form}
          skuList={this.props.skuList}
          addOrUpdateOrder={this.props.addOrUpdateOrder}
          editOrderId={this.props.editOrderId}
          orderList={this.props.orderList}
          cancelEditForm={this.props.cancelEditForm}
          customData={customData}
          getSkuList={this.props.getSkuList}
          getMoney={this.props.getMoney}
          money={this.props.money}
        >
        </CustomOrderInputForm>
        {/* 定制单表格 */}
        <CustomOrderInputTable
          orderList={this.props.orderList}
          skuList={this.props.skuList}
          delTableRow={this.props.delTableRow}
          editTableRow={this.props.editTableRow}
          customData={customData}
          _setFormByEdit={this._setFormByEdit}
        >
        </CustomOrderInputTable>
        {/* 出行人上传 */}
        <CustomOrderFileUpload
          uploadFile={this.props.uploadFile}
          addUploadFile={this.props.addUploadFile}
          customerFile={this.props.customerFile}
          customData={customData}
        >
        </CustomOrderFileUpload>
        {/* CustomOrderActionButtons */}
        <div className={'customOrderContianerActions'}>
          {this.getActionButton()}
        </div>
      </div>
    )
  }
}

export default CustomOrder